<template>
  <v-card id="check-list-container">
      <v-card-title class="check-list-title">
        {{ $t('pathManagement.checklist.path') }} <div :class="pathConditionsProgress === pathConditions.length ? 'ml-4 primary--text' : 'ml-4'"> {{ pathConditionsProgress }} / {{ pathConditions.length }}</div>
      </v-card-title>
      <div
          v-for="condition in pathConditions"
          :class="condition.disabled ?'check-list-row' : 'check-list-row editable-row'"
          :key="condition.id"
          @click="saveUpdate(condition)""
        >
          <v-icon v-if="condition.isChecked" style="padding-left: 16px; padding-right: 16px; padding-top: 6px; padding-bottom: 6px;" class="row-element" :color="'primary'">mdi-checkbox-marked-circle-outline</v-icon>
          <v-icon v-else style="padding-left: 16px; padding-right: 16px; padding-top: 6px; padding-bottom: 6px;" class="row-element" :color="condition.disabled ? 'grey' : 'black'">mdi-checkbox-blank-circle-outline</v-icon>
          <v-card-text
            :class="condition.isChecked ? 'primary--text row-element row-text done' : condition.disabled ? 'row-element row-text grey--text' : 'row-element row-text'"
            >
            {{condition.name}}
          </v-card-text>
      </div>
      <v-card-title class="check-list-title">
        {{ $t('pathManagement.checklist.missions') }} <div :class="missionsConditionsProgress === missionsConditions.length ? 'ml-4 primary--text' : 'ml-4'"> {{ missionsConditionsProgress }} / {{ missionsConditions.length }}</div>
      </v-card-title>
      <div
          v-for="condition in missionsConditions"
          :class="condition.disabled ?'check-list-row' : 'check-list-row editable-row'"
          :key="condition.id"
          @click="saveUpdate(condition)"
        >
          <v-icon v-if="condition.isChecked" style="padding-left: 16px; padding-right: 16px; padding-top: 6px; padding-bottom: 6px;" class="row-element" :color="'primary'">mdi-checkbox-marked-circle-outline</v-icon>
          <v-icon v-else style="padding-left: 16px; padding-right: 16px; padding-top: 6px; padding-bottom: 6px;" class="row-element" :color="condition.disabled ? 'grey' : 'black'">mdi-checkbox-blank-circle-outline</v-icon>
          <v-card-text
          :class="condition.isChecked ? 'primary--text row-element row-text done' : condition.disabled ? 'row-element row-text grey--text' : 'row-element row-text'"
            >
            {{condition.name}}
          </v-card-text>
      </div>
      <v-card-title class="check-list-title">
        {{ $t('pathManagement.checklist.account') }} <div :class="accountConditionsProgress === accountConditions.length ? 'ml-4 primary--text' : 'ml-4'"> {{ accountConditionsProgress }} / {{ accountConditions.length }}</div>
      </v-card-title>
      <div
          v-for="condition in accountConditions"
          :class="condition.disabled ?'check-list-row' : 'check-list-row editable-row'"
          :key="condition.id"
          @click="saveUpdate(condition)" 
          >
          <v-icon v-if="condition.isChecked" style="padding-left: 16px; padding-right: 16px; padding-top: 6px; padding-bottom: 6px;" class="row-element" :color="'primary'">mdi-checkbox-marked-circle-outline</v-icon>
          <v-icon v-else style="padding-left: 16px; padding-right: 16px; padding-top: 6px; padding-bottom: 6px;" class="row-element" :color="condition.disabled ? 'grey' : 'black'">mdi-checkbox-blank-circle-outline</v-icon>
          <v-card-text
          :class="condition.isChecked ? 'primary--text row-element row-text done' : condition.disabled ? 'row-element row-text grey--text' : 'row-element row-text'"
            >
            {{condition.name}}
          </v-card-text>
      </div>
  </v-card>
</template>


<script>

export default {
  name: 'checkList',
  components: {
  },
  props: {
    pathInfos: {
      type: Object,
      default: null
    },
    missionsInfos: {
      type: Object,
      default: null
    },
    accountInfos: {
      type: Object,
      default: null
    },
    checkListElements: {
      type: Array,
      default: () => []
    },
    pathId: {
      type: String,
      default: null
    },
    previewMode: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    pathInfos() {
      for (const key in this.missionsInfos) {
        this.missionsConditions.find(c => c.id === key).isChecked = this.missionsInfos[key];
      }

      for (const key in this.pathInfos) {
        this.pathConditions.find(c => c.id === key).isChecked = this.pathInfos[key];
      }

      for (const key in this.accountInfos) {
        this.accountConditions.find(c => c.id === key).isChecked = this.accountInfos[key];
      }
    }
  },
  data() {
  	return {
      pathConditions: [
        {
          name: this.$t('pathManagement.checklist.pathConditions.help'),
          id: 'help',
          disabled: false,
          isChecked: false,
        },
        {
          name: this.$t('pathManagement.checklist.pathConditions.name'),
          id: 'name',
          disabled: true,
          isChecked: false,
        },
        {
          name: this.$t('pathManagement.checklist.pathConditions.img'),
          id: 'img',
          disabled: true,
          isChecked: false,
        },
        {
          name: this.$t('pathManagement.checklist.pathConditions.intro'),
          id: 'intro',
          disabled: true,
          isChecked: false,
        },
            
        {
          name: this.$t('pathManagement.checklist.pathConditions.conclusion'),
          id: 'conclusion',
          disabled: true,
          isChecked: false,
        },
        {
          name: this.$t('pathManagement.checklist.pathConditions.ortho'),
          id: 'ortho',
          disabled: false,
          isChecked: false,
        },
        {
          name: this.$t('pathManagement.checklist.pathConditions.test'),
          id: 'test',
          disabled: false,
          isChecked: false,
        }
      ],
      missionsConditions: [
        {
          name: this.$t('pathManagement.checklist.missionsConditions.mission'),
          id: 'mission',
          disabled: true,
          isChecked: false,
        },
        {
          name: this.$t('pathManagement.checklist.missionsConditions.3mission'),
          id: '3mission',
          disabled: true,
          isChecked: false,
        },
      ],
      accountConditions: [
        {
          name: this.$t('pathManagement.checklist.accountConditions.logo'),
          id: 'logo',
          disabled: true,
          isChecked: false,
        },
        // {  ** TODO: décommenter PathManagement computed accountInfos
        //     name: this.$t('pathManagement.checklist.accountConditions.socials'),
        //     id: 'socials',
        //     disabled: true,
        //     isChecked: false,
        // },
        {
          name: this.$t('pathManagement.checklist.accountConditions.communicate'),
          id: 'communicate',
          disabled: false,
          isChecked: false,
        }
      ]
    };
  },
  mounted() { // mise à jour des elements de la checklist et de leur état en fonctions des props passées
    if (this.access.includes('lang')) {
      this.pathConditions.push({
        name: this.$t('pathManagement.checklist.pathConditions.translate'),
        id: 'translate',
        disabled: true,
        isChecked: false,
      });
    }
    // JCS: en double avec watch ?
    // à factoriser
    for (const key in this.missionsInfos) {
      this.missionsConditions.filter(c => c.id === key)[0].isChecked = this.missionsInfos[key];
    }

    for (const key in this.pathInfos) {
      this.pathConditions.filter(c => c.id === key)[0].isChecked = this.pathInfos[key];
    }

    for (const key in this.accountInfos) {
      this.accountConditions.filter(c => c.id === key)[0].isChecked = this.accountInfos[key];
    }

    if (this.checkListElements) {
      this.checkListElements.forEach(k => { // mise à jour des élément chargés depuis le back
        if (this.pathConditions.filter(c => c.id === k).length > 0)
        {this.pathConditions.filter(c => c.id === k)[0].isChecked = true;}
        if (this.accountConditions.filter(c => c.id === k).length > 0)
        {this.accountConditions.filter(c => c.id === k)[0].isChecked = true;}
      });
    }
  },
  computed: {
    pathConditionsProgress() {
      return this.pathConditions.filter(c => c.isChecked).length;
    },
    missionsConditionsProgress() {
      return this.missionsConditions.filter(c => c.isChecked).length;
    },
    accountConditionsProgress() {
      return this.accountConditions.filter(c => c.isChecked).length;
    },
    access() {
      return this.$store.getters['paths/getPathsAccess'][this.$route.params.pathId] || [];
    },
  },
  
  methods: {
    async saveUpdate(condition) { // Save uniquement les élements de la checklist à cocher manuellement

      if (condition.disabled || this.previewMode) // si disabled alors return pour ne pas fausser la liste save && la progress bar
      {return;}
     
      var arr = JSON.parse(JSON.stringify(this.checkListElements)); // deepclone des elements cochés manuellement pour ne pas edit les props

      if (arr.includes(condition.id)) { // si elements existants, alors delete de la liste
        var index = arr.indexOf(condition.id);
        arr.splice(index, 1);
      } else { // sinon ajout dans la liste
        arr.push(condition.id);
      }

      // update condition data
      this.accountConditions.map(c => {
        if (c.id === condition.id) {c.isChecked = !c.isChecked;}
        return c;
      });
      this.pathConditions.map(c => {
        if (c.id === condition.id) {c.isChecked = !c.isChecked;}
        return c;
      });


      await this.updatePath({checklist: arr}); // save de la liste
    },
    async updatePath(payload) {
      try {
        await this.$store.dispatch('paths/UPDATE_PATH', {
          pathPayload: payload,
          index: this.$store.getters['auth/currentUserIndex'],
          pathId: this.pathId,
          kuzzle: this.$kuzzle
        });
      } catch (e) {
        console.log('updatechecklist error',e);
        this.$toast.show(e);
      }
      this.$store.commit('app/UNSET_LOADING');
    },
  }
};
</script>

<style lang="sass" scoped>

.done
  text-decoration-line: line-through;
.check-list-row
  display: inline-block
  width: 100%;
.editable-row
  cursor: pointer;
.row-element
  float: left;
  width: 25% !important;
.check-list-title
  margin-left: 10%;
  font-size: 1.3em;
  font-weight: bold;
  padding: 6px !important;

.v-card__title
  ::v-deep .check-list-title
    padding: 6px;

.v-card__text
  padding-left: 16px !important;
  padding-right: 16px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
.row-text
  width: 60% !important;
</style>